import { PackageOpen } from 'lucide-react'
import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'
import { type ProductDraft } from '#app/routes/mocra+/_form+/components/products/types.ts'

type Props = {
	readonly index: number
	readonly product: ProductDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly disableRemove?: boolean
	readonly errors?: readonly string[]
}

export function ProductCard({
	index,
	product,
	onEdit,
	onRemove,
	disableRemove,
	errors,
}: Props) {
	const trimmedName = product.name.trim()
	const displayName =
		trimmedName.length > 0 ? trimmedName : `Product ${index + 1}`

	const trimmedSku = product.sku.trim()
	const hasSku = trimmedSku.length > 0
	const skuLabel = hasSku ? `SKU: ${trimmedSku}` : 'SKU not provided'
	const hasErrors = Boolean(errors && errors.length > 0)
	const description = hasErrors ? `${skuLabel} • Needs attention` : skuLabel

	return (
		<EntityCard
			title={displayName}
			description={description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={disableRemove}
			removeAriaLabel={`Remove product ${index + 1}`}
			removeLabel="Remove"
			removeConfirmTitle={`Remove ${displayName}?`}
			removeConfirmDescription="This product will be removed from the roster. You can add it again later."
			icon={
				<PackageOpen
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
		/>
	)
}
